<template>
    <div v-if="isIdle === true && DisableConfirmation === false">
      <v-dialog v-model="isIdle" max-width="370">
        <v-card class="pt-10 px-10">
          <v-card-text class="idle-text">{{messageText}}</v-card-text>
          <v-card-actions style="width:100%" class="mx-auto text-center">
            <v-btn color="primary" @click="isIdle = false">{{ButtonText}}</v-btn>  
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: "IdleTimeout",
    props: {
      IdleTimeout: Number,
      WarningTimeout: Number,
      DialogText: { required: true },
      ButtonText: { required: true },
      DisableConfirmation: Boolean
    },
    data() {
      return {
        idleTimer: "",
        warningTimer: "",
        countDownInterval: "",
        isIdle: Boolean,
        isTimedOut: Boolean,
        secondsRemaining: Number
      };
    },
    computed: {
      messageText() {
        return this.DialogText.replace("##", this.secondsRemaining);
      },
      idleTimeoutValue() {
        return this.IdleTimeout || 20;
      }
    },
    created() {
      this.isIdle = false;
      this.secondsRemaining = 30;
      this.startIdleTimeOut();
      document.addEventListener("click", this.onRefresh);
      document.addEventListener("mousemove", this.onRefresh);
    },
    methods: {
      onRefresh() {
        if (this.idleTimer && !this.isIdle) {
          clearTimeout(this.idleTimer);
          this.startIdleTimeOut();
        }
        if (this.warningTimer) {
          clearTimeout(this.warningTimer);
          clearInterval(this.countDownInterval);
        }
      },
      setIsIdle(value) {
        this.isIdle = value;
      },
      warningTimeout() {
        this.setIsIdle(false);
        this.$emit("OnWarningTimeout");
      },
      idleTimeout() {
        this.setIsIdle(true);
        this.startWarningTimeout();
      },
      startIdleTimeOut() {
        let idleTimeout = this.idleTimeout;
        this.idleTimer = setTimeout(function() {
          idleTimeout();
        }, this.idleTimeoutValue * 1000);
      },
      startWarningTimeout() {
        let warningTimeout = this.warningTimeout;
        if (this.DisableConfirmation === false) {
          this.startWarningCountDown();
          this.warningTimer = setTimeout(function() {
            warningTimeout();
          }, 30 * 1000);
        } else {
          warningTimeout();
        }
      },
      startWarningCountDown() {
        this.secondsRemaining = 30;
        let decrementSecondsRemaining = this.decrementSecondsRemaining;
        this.countDownInterval = setInterval(function() {
          decrementSecondsRemaining();
        }, 1000);
      },
      decrementSecondsRemaining() {
        --this.secondsRemaining;
      }
    }
  };
  </script>
  
  <style scoped>
  .v-btn {
    height: 50px !important;
    color: white !important;
    width: 260px;
  }
  </style>
  